<template>
    <div class="mx-3">
        <b-card no-body class="shadow">
                <b-tabs card >
                    <!--XXX When setting permission in templates, use v-if="hasPermission('permission-name')"-->
                    <b-tab
                        title="Mantenedor de empresa"
                    >
                        <template #title>
                            <div title="Mantenedor de empresa" v-b-tooltip.hover.right>
                                <b-icon icon="briefcase"></b-icon>
                            </div>
                        </template>

                        <!--cuerpo de la lista-->
                        <SettingCompany />
                    </b-tab>
                </b-tabs>
        </b-card>
    </div>
</template>
<script>
import SettingCompany from '@/components/Setting/ListSetting/Setting-company.vue'

export default {
    name: 'ListSetting',

    data() {
        return {
            showCompanyManager: true,
        }
    },

    components:{
        SettingCompany,
    }
}
</script >
<style>
</style>
